import type { PickitupTheme } from '../../features/FeatureState';

export type ThemeVisual = {
  id: PickitupTheme;
  label: string;
  bgTop: number;
  bgBottom: number;
  outerA: number;
  outerB: number;
  innerA: number;
  innerB: number;
  fieldA: number;
  fieldB: number;
  panelA: number;
  panelB: number;
  accent: number;
  accent2: number;
  accent3: number;
  stroke: number;
  strokeSoft: number;
  buttonA: number;
  buttonB: number;
  text: string;
  dim: string;
  good: number;
  warn: number;
  bad: number;
};

export const THEME_VISUALS: Record<PickitupTheme, ThemeVisual> = {
  classic: {
    id: 'classic', label: 'Classic Neon', bgTop: 0x050818, bgBottom: 0x120833,
    outerA: 0x3a1870, outerB: 0x160a40, innerA: 0x0a0420, innerB: 0x050210,
    fieldA: 0x0d0318, fieldB: 0x06010d, panelA: 0x180840, panelB: 0x100630,
    accent: 0x00ffee, accent2: 0xff44ff, accent3: 0xffd644, stroke: 0x9955ff, strokeSoft: 0x6838bb,
    buttonA: 0x00ddcc, buttonB: 0x008899, text: '#f0e8ff', dim: '#9988cc', good: 0x33ffaa, warn: 0xffcc22, bad: 0xff3366,
  },
  royal: {
    id: 'royal', label: 'Royal Gold', bgTop: 0x100804, bgBottom: 0x2a1603,
    outerA: 0x7c4a05, outerB: 0x241203, innerA: 0x1e1004, innerB: 0x090502,
    fieldA: 0x1a0d03, fieldB: 0x070301, panelA: 0x2c1805, panelB: 0x130802,
    accent: 0xffd45a, accent2: 0xff7a1a, accent3: 0xfff0a8, stroke: 0xd49a25, strokeSoft: 0x7a5516,
    buttonA: 0xffc23d, buttonB: 0xb86a08, text: '#fff4cf', dim: '#d4ad67', good: 0x66f0a3, warn: 0xffcc22, bad: 0xff4d4d,
  },
  neon: {
    id: 'neon', label: 'Cyber Neon', bgTop: 0x02081a, bgBottom: 0x1a0324,
    outerA: 0x006d88, outerB: 0x340040, innerA: 0x04132d, innerB: 0x0a0214,
    fieldA: 0x051126, fieldB: 0x03040e, panelA: 0x061c3a, panelB: 0x170326,
    accent: 0x16f2ff, accent2: 0xff2bd6, accent3: 0x8b5cff, stroke: 0x13d8ff, strokeSoft: 0x5b38ff,
    buttonA: 0x18f2ff, buttonB: 0xc018ff, text: '#e7fbff', dim: '#84b8ff', good: 0x35ffb6, warn: 0xfff15a, bad: 0xff3366,
  },
  forest: {
    id: 'forest', label: 'Lucky Forest', bgTop: 0x04140c, bgBottom: 0x09240f,
    outerA: 0x0f5a2a, outerB: 0x06200d, innerA: 0x082315, innerB: 0x020b05,
    fieldA: 0x082011, fieldB: 0x031008, panelA: 0x0c3219, panelB: 0x06160b,
    accent: 0x50f29a, accent2: 0xb8ff5b, accent3: 0xffd45a, stroke: 0x3ddc84, strokeSoft: 0x1f7c4e,
    buttonA: 0x44dd83, buttonB: 0x13844b, text: '#e9ffef', dim: '#95caa7', good: 0x50f29a, warn: 0xffd45a, bad: 0xff5a5a,
  },
  midnight: {
    id: 'midnight', label: 'Midnight', bgTop: 0x020613, bgBottom: 0x070924,
    outerA: 0x14356d, outerB: 0x070b22, innerA: 0x081229, innerB: 0x02040d,
    fieldA: 0x071021, fieldB: 0x020511, panelA: 0x0b1836, panelB: 0x05091b,
    accent: 0x93c5fd, accent2: 0x6366f1, accent3: 0xc4b5fd, stroke: 0x7aa9ff, strokeSoft: 0x354b8c,
    buttonA: 0x5da8ff, buttonB: 0x304dba, text: '#eff6ff', dim: '#93a4ca', good: 0x7df5c1, warn: 0xfacc15, bad: 0xfb7185,
  },
  candy: {
    id: 'candy', label: 'Candy Pop', bgTop: 0x1c061d, bgBottom: 0x2a0a36,
    outerA: 0xd946ef, outerB: 0x6d1d8e, innerA: 0x2a0f35, innerB: 0x110516,
    fieldA: 0x2a1030, fieldB: 0x100514, panelA: 0x401544, panelB: 0x1d0825,
    accent: 0xf9a8d4, accent2: 0x67e8f9, accent3: 0xfde047, stroke: 0xf472b6, strokeSoft: 0x9d4edd,
    buttonA: 0xff8ad8, buttonB: 0x8b5cf6, text: '#fff1fb', dim: '#e9a8dc', good: 0x86efac, warn: 0xfde047, bad: 0xfb7185,
  },
};

export function hexColor(color: number): string {
  return `#${color.toString(16).padStart(6, '0')}`;
}
